// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__ObnYF","col":"Table_col__oi5nB","fulfillmentStatus":"Table_fulfillmentStatus__3B125","emailCol":"Table_emailCol__1-tMy"};